<style lang="less">
    .page_con.ass{
        width:100vw;
        height:100vh;
        overflow: hidden;
        background:url("../assets/images/bg3.png") no-repeat;
        background-size: 100% 100%;
        .top_con{
            width:100%;
            height:11vh;
            padding:0 5vw;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            background:url("../assets/images/topbar-5.png") no-repeat;
            background-size: 100% 100%;
            img{
                width:.6rem;
                height:auto;
                display: block;
            }
            p{
                font-size: .4rem;
                color:#fff;
                font-weight: bold;
                margin-left:.1rem;
                letter-spacing: .05rem;
            }
        }
        .content_con{
            width:100%;
            height:79vh;
            .part1{
                .text_con{
                    width:100%;
                    margin:20vh 0 0;
                    padding:5vh 10vw;
                    height:40vh;
                    font-size: .5rem;
                    background:#FCD587;
                    p{
                        padding:0 10vw;
                    }
                    .words{
                        width:100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        margin-top:3vh;
                        >div{
                            width:30vw;
                            height:30vw;
                            line-height:28vw;
                            background:#F9C46B;
                            text-align: center;
                            font-size: 1.4rem;
                            color:#000;
                            border-radius: .15rem;
                        }
                        >div:first-child{
                            margin-right:2vw;
                        }
                    }
                }
                .start_btn{
                    img{
                        width:30vw;
                        height:auto;
                        display: block;
                        margin:10vh auto 0;
                    }
                }
            }
            .part2{
                .question_con{
                    width:100%;
                    height:30vh;
                    background:#FCD587;
                    padding-top:3vh;
                    .keyword{
                        height:20vh;
                        line-height:20vh;
                        font-size: 1.2rem;
                        text-align: center;
                    }
                    .ask_tips{
                        font-size: .4rem;
                        // font-weight: bold;
                        text-align: center;
                    }
                }
                .answer_con{
                    width:100%;
                    padding:10vh 0;
                    .answers{
                        width:100%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        flex-wrap: wrap;
                        >div{
                            width:30%;
                            font-size: .8rem;
                            padding:.5vh 0;
                            // letter-spacing: .2rem;
                            text-align: center;
                            border-radius: .2rem;
                            color:#fff;
                            margin:0 1% 2vh 0;
                            border: 6px solid transparent;
                        }
                        >div.active{
                            border-color:#fff;
                            box-shadow: 0 2px 6px 0 rgba(0,0,0,.2);
                        }
                        >div:nth-child(3n){
                            margin-right:0;
                        }
                    }
                }
            }
        }
        .btns{
            width:100%;
            height:10vh;
            // position: fixed;
            bottom: 0;
            left: 0;
            z-index: 11;
            padding:0 5vw;
            display: flex;
            align-items: center;
            justify-content: space-between;
            img{
                width:25vw;
                height:auto;
                display: block;
            }
        }
    }
</style>
<template>
    <div class="page_con ass">
        <div class="top_con">
            <img src="../assets/images/time.png" alt="">
            <interval :time="time" ref="time"></interval>
        </div>
        <!-- <div class="quest_num">
            <img src="../assets/images/grade-button.png" alt="">
            <p>第112題</p>
        </div> -->
        <div class="content_con">
            <div class="part1" v-if="part === 1">
                <div class="text_con">
                    <p>請選出可跟一下詞句搭配的詞語。</p>
                    <div class="words">
                        <div class="word_item" v-for="(item,index) in data.word.split('')" :key="index">{{item}}</div>
                        <!-- <div class="word_item">合</div> -->
                    </div>
                </div>
                <div class="start_btn">
                    <img src="../assets/images/start-button.png" @click="part=2" alt="">
                </div>
            </div>
            <div class="part2" v-if="part === 2">
                <div class="question_con">
                    <p class="keyword">【{{data.word}}】</p>
                    <p class="ask_tips">{{data.topics2}}</p>
                </div>
                <div class="answer_con">
                    <div class="answers">
                        <div v-for="(item,index) in data.options" :key="index" :style="'background:'+item.color" :class="[item.choiced?'active':'']" @click="item.choiced=!item.choiced">
                            {{item.text}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="btns" v-if="part === 2">
            <img src="../assets/images/back-button.png" @click="$router.go(-1)" alt="">
            <img src="../assets/images/submit.png" @click="saveData" alt="">
        </div>
        
        <div class="shade" v-if="toast != 'none'">
            <div class="toast" v-if="toast != 'none'">
                <div v-if="toast == 'success'" class="toast_success">
                    <img class="result" src="../assets/images/DONE-answer.png" alt="">
                    <img src="../assets/images/backhome.png" alt="" class="goon" @click="$router.push('/index')">
                </div>
                <div v-if="toast == 'error'" class="toast_error">
                    <img class="result" src="../assets/images/NO-answer.png" alt="">
                    <img src="../assets/images/continue.png" alt="" class="goon" @click="reset">
                </div>
            </div>
        </div>
        
        <div class="shade" v-if="tips_bag || toast != 'none'">
            <div class="tips_bag" v-if="tips_bag">
                <img src="../assets/images/tip-bg.png" alt="">
                <img class="close" src="../assets/images/close-tipbutton.png" alt="" @click="tips_bag='close'">
                
                <p v-if="data.tips" v-html="data.tips"></p>
                <p v-else style="text-align:center;" v-html="'今天沒有學習錦囊'"></p>
            </div>


            <div class="toast" v-if="toast != 'none'">
                <div v-if="toast == 'success'" class="toast_success">
                    <template v-if="isEnd">
                        <img class="result" src="../assets/images/DONE-answer.png" alt="">
                        <img src="../assets/images/backhome.png" alt="" class="goon" @click="answerEnd">
                    </template>
                    <template v-else>
                        <img class="result" src="../assets/images/yes-answer.png" alt="">
                        <img src="../assets/images/next.png" alt="" class="goon" @click="next">
                    </template>
                </div>
                <div v-if="toast == 'error'" class="toast_error">
                    <img class="result" src="../assets/images/NO-answer.png" alt="">
                    <img src="../assets/images/continue.png" alt="" class="goon" @click="reset">
                </div>
            </div>
        </div>
        <div class="shade tips_result" v-if="tips_bag == 'close'">
            <div class="tips_result">
                <img class="readed" src="../assets/images/read-done.png" alt="">
                <img class="close" @click="tips_bag=false" src="../assets/images/certain-button.png" alt="">
            </div>
        </div>
    </div>
</template>
<script>
import interval from './timer';
export default {
    components:{
        interval
    },
    data(){
        return {
            pauseStatus:false,  //暫停狀態
            time:300,    //倒計時
            
            setsIndex:0,        //当前第几套题
            isEnd:false,        //是否结束
            
            tips_bag:'',
            toast:'none',
            tips_time:0,        //锦囊使用次数
            is_right:1,
            
            part:1,
            toast:'none',
            colors_src:['#385C77','#EC6C68','#EE8538','#E60012','#00913A','#595757','#956134','#8C7AB7','#2FA8E1'],
            colors:[],
            data:{
                tips:'',
                topics:'',
                word:'',
                topics2:'可搭配的詞語（可選擇多個答案）',
                options:[
                    // {
                    //     text:'要求',
                    //     id:'1',
                    //     color:'#385C77',
                    //     choiced:false,
                    // },
                ],
            }
        }
    },
    mounted() {
        let query = this.$route.query;
        this.getData(query.date);
    },
    methods: {
        answerEnd(){
            this.updateData(this.getTime(),this.tips_time,this.is_right,this.$route.query.date);
        },
        saveData(){
            let is_right = this.data.options.every(v=>{
                return v.right == v.choiced
            });
            if(is_right){
                if(this.hasMore()){
                    this.toast = 'success';
                    // this.next();
                }else{
                    this.isEnd = true;
                    this.toast = 'success';
                }
            }else{
                this.toast = 'error';
            }
        },
        getTime(){
            return this.time - this.$refs.time.getTime();
        },
        reset(){
            this.data.options.map(v=>{
                v.choiced = false;
                return v;
            });
            this.toast = 'none';
        },
        hasMore(){
            let setsIndex = this.setsIndex + 1;
            if(this.$store.getters.gameData[setsIndex]){
                return true;
            }else{
                return false;
            }
        },
        next(){
            if(this.hasMore()){
                this.setsIndex += 1;
                this.part = 1;
                this.reset();
                this.init(this.setsIndex);
            }
        },
        getData(date){
            let vm = this;
            vm.$http.get('/GameDaily/index?type=11&rest_key=1'+(date?('&pushdate='+date):'')).then(res=>{
                console.log(res);
                if(res.data.code == 1){
                    vm.$store.commit('setGameData',res.data.data.game);
                    vm.init(vm.setsIndex);
                }
            })
        },
        init(sets){
            // console.log(this.$store.getters.gameData[1]);
            this.colors = JSON.parse(JSON.stringify(this.colors_src));
            let data = JSON.parse(JSON.stringify(this.$store.getters.gameData[sets]));
            data.options = data.options.map(v=>{
                return {
                    text:v.option,
                    right:v.right,
                    id:v.code,
                    color:this.randomColor(),
                    choiced:false,
                }
            });
            data.options = this.randomIndex(data.options);
            this.data = data;
            console.log(data);
        },
        randomColor(){
            let i = parseInt(Math.random()*this.colors.length);
            return this.colors.splice(i,1)[0];
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/assembly.vue